// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// // import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//性能优化
// reportWebVitals();


import {React} from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Route
} from "react-router-dom";
import App from './App';
import './util/rem.js';
import './assets/css/base.css'

renderDom()
function renderDom() {
    ReactDOM.render(
        <Router>

            <Route component={App}/>
        </Router>, document.getElementById('root')
    );
}
